export function downloadByteArray(reportName, byte, fileType) {
    let blob = new Blob([atob(byte)], { type: fileType });
    let link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    let fileName = reportName;
    link.download = fileName;
    link.click();
};
